import './sidenav.css'

export default function Sidecntp(props) {
  return (
    <div className='sidecntp' style={{backgroundColor:props.bgcolor}}>
        <div className='sideicon'>
            {/* <Profile fill="#ffffff"/> */}
            {props.componentToPassDown}
        </div>
        <div className='sidename'>{props.name}</div>
    </div>
  )
}